import { collapseAndDisableSection, expandAndEnableSection } from "./modules/collapse";

const axios = require("axios");

export function addGetAddressListeners() {
  const streetNumber = document.getElementById("billing_street_number");
  const postcode = document.getElementById("billing_postcode");

  if (!streetNumber || !postcode) {
    return;
  }

  [streetNumber, postcode].forEach((element) => {
    element.addEventListener("blur", () => {
      fillAddress(postcode.value, streetNumber.value);
    });
  });

  const factuurStreetNumber = document.getElementById("shipping_street_number");
  const factuurPostcode = document.getElementById("shipping_postcode");

  if (!factuurStreetNumber || !factuurPostcode) {
    return;
  }

  [factuurStreetNumber, factuurPostcode].forEach((element) => {
    element.addEventListener("blur", () => {
      fillFactuurAddress(factuurPostcode.value, factuurStreetNumber.value);
    });
  });
}

async function fillFactuurAddress(postcode, streetNumber) {
  if (postcode == "" || streetNumber == "") {
    return;
  }

  postcode = postcode.replace(" ", "");

  if (!/^\d{4}[[a-zA-Z]{2}$/.test(postcode)) {
    document.querySelector("#shipping_postcode_field span.error.postcode").style.display = "";
    return;
  }
  document.querySelector("#shipping_postcode_field span.error.postcode").style.display = "none";

  if (
    fillAddress.postcode != postcode ||
    fillAddress.streetNumber != streetNumber ||
    typeof fillAddress.fullAddress == "undefined"
  ) {
    fillAddress.fullAddress = await getAddress(postcode, streetNumber);

    fillAddress.postcode = postcode;
    fillAddress.streetNumber = streetNumber;
  }

  const shipping_street = document.getElementById("shipping_street");
  const shipping_city = document.getElementById("shipping_city");

  if (fillAddress.fullAddress == false) {
    shipping_street.value = "";
    shipping_street.disabled = false;
    shipping_city.value = "";
    shipping_city.disabled = false;

    document.querySelector("#shipping_postcode_field span.error.no-result").style.display = "";
    return;
  }
  document.querySelector("#shipping_postcode_field span.error.no-result").style.display = "none";

  shipping_street.value = fillAddress.fullAddress.street;
  shipping_street.disabled = false;

  shipping_city.value = fillAddress.fullAddress.city;
  shipping_city.disabled = false;
}

async function fillAddress(postcode, streetNumber) {
  if (postcode == "" || streetNumber == "") {
    return;
  }

  postcode = postcode.replace(" ", "");

  if (!/^\d{4}[[a-zA-Z]{2}$/.test(postcode)) {
    document.querySelector("#billing_postcode_field span.error.postcode").style.display = "";
    return;
  }
  document.querySelector("#billing_postcode_field span.error.postcode").style.display = "none";

  if (
    fillAddress.postcode != postcode ||
    fillAddress.streetNumber != streetNumber ||
    typeof fillAddress.fullAddress == "undefined"
  ) {
    fillAddress.fullAddress = await getAddress(postcode, streetNumber);

    fillAddress.postcode = postcode;
    fillAddress.streetNumber = streetNumber;
  }

  const billing_street = document.getElementById("billing_street");
  const billing_city = document.getElementById("billing_city");
  const billing_province = document.getElementById("billing_province");
  const billing_municipality = document.getElementById("billing_municipality");

  if (fillAddress.fullAddress == false) {
    billing_street.value = "";
    billing_street.disabled = false;
    billing_city.value = "";
    billing_city.disabled = false;
    if (billing_province) {
      billing_province.value = "";
      billing_province.disabled = false;
    }
    if (billing_municipality) {
      billing_municipality.value = "";
      billing_municipality.disabled = false;
    }
    document.querySelector("#billing_postcode_field span.error.no-result").style.display = "";
    return;
  }

  document.querySelector("#billing_postcode_field span.error.no-result").style.display = "none";

  billing_street.value = fillAddress.fullAddress.street;
  billing_street.disabled = false;

  billing_city.value = fillAddress.fullAddress.city;
  billing_city.disabled = false;
  if (billing_province) {
    billing_province.value = fillAddress.fullAddress.province;
    billing_province.disabled = false;
  }
  if (billing_municipality) {
    billing_municipality.value = fillAddress.fullAddress.municipality;
    billing_municipality.disabled = false;
  }
}

async function getAddress(postcode, houseNo) {
  let res = axios
    .get(`https://postcode.tech/api/v1/postcode/full?postcode=${postcode}&number=${houseNo}`, {
      headers: {
        Authorization: "Bearer " + "56bee622-4f3f-4342-8f41-c001561a17d7",
      },
    })
    .then((res) => {
      return res;
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error", error.message);
      }
      console.error(error.config);
    });

  let result = await res;

  if (typeof result == "undefined") {
    return false;
  }

  return result.data;
}
